import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';

const keyOf = productId => `mc-assistant-${productId}`;
const freshId = () => `a${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

// One running conversation per article (kept on this device); older ones are listed via /assistant/conversations.
export function useAssistantSession(productId) {
  const [session, setSession] = useState(() => localStorage.getItem(keyOf(productId)) || freshId());
  const [messages, setMessages] = useState([]), [loading, setLoading] = useState(true), [list, setList] = useState(null);
  useEffect(() => {
    localStorage.setItem(keyOf(productId), session);
    let alive = true; setLoading(true);
    // Messages typed while the history loads (autostart) stay after the loaded ones.
    studioApi(`/assistant/history?session_id=${session}`)
      .then(d => { if (alive) setMessages(prev => [...(d.messages || []).map((m, i) => ({ ...m, key: `${session}-${i}` })), ...prev.filter(m => m.fresh)]); })
      .catch(() => {}).finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [session, productId]);
  const loadList = () => studioApi('/assistant/conversations').then(d => setList(d.items || [])).catch(() => setList([]));
  const open = id => { if (id === session) return; setMessages([]); setSession(id); };
  const startNew = () => { setMessages([]); setSession(freshId()); };
  const setThumb = assetId => studioApi('/assistant/conversations/thumb', { method: 'POST', body: { session_id: session, asset_id: assetId } }).catch(() => {});
  return { session, messages, setMessages, loading, list, loadList, open, startNew, setThumb };
}
